import * as vp from 'vopay';
import { useEffect, FC, useState } from 'react';
import useFetchACHWithdrawTransaction from '@/hooks/useApi/useFetchACHWithdrawTransaction';
import AchWithdrawalTransactionInfo from './ACHWithdrawalTransactionInfo';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

type AchWithdrawalTransactionProps = {
  TransactionID: string;
  Notes: string;
  isParent?: boolean;
  jwt: string;
};

const AchWithdrawalTransactionContainer: FC<AchWithdrawalTransactionProps> = ({
  TransactionID,
  Notes,
  isParent = false,
  jwt,
}) => {
  const { userSettings } = useUserSettingsProvider();
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.ACHWithdrawTransactionResponse>();
  const [achWithdrawalTransaction, getAchWithdrawTransaction, resetTransactionsId] = useFetchACHWithdrawTransaction({
    bearer: jwt,
  });

  useEffect(() => {
    getAchWithdrawTransaction({ TransactionID, Timezone: userSettings.timezone });
  }, [currentTransactionId, TransactionID]);

  useEffect(() => {
    if (achWithdrawalTransaction) {
      setTransaction(achWithdrawalTransaction);
    }
  }, [achWithdrawalTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
    resetTransactionsId();
  }

  return (
    <div>
      {transaction && (
        <AchWithdrawalTransactionInfo transaction={transaction} Notes={Notes} isParent={isParent} jwt={jwt} />
      )}
    </div>
  );
};

export default AchWithdrawalTransactionContainer;
